// User API
export const LOGIN_API = '/login';
export const GET_LOGGED_IN_USER_API = '/users/user/get-logged-in-user'; // userId
export const REGISTER_API = '/users/register';
export const RESET_PASSWORD_API = '/users/user/reset-password'; // userId
export const DELETE_ACCOUNT_API = '/users/user/delete-account'; // userId
export const VERIFY_EMAIL_API = '/users/verify-email-address'; // userId

// Domination forms API
export const SUBMIT_DOMINATION_FORM_API = '/domination/create-new-domination-form'; 
export const GET_ALL_DOMINATION_FROMS_API = '/domination/get-all-domination-forms'; 
export const DELETE_DOMINATION_FORM_API = '/domination/delete-domination-form'; 
export const DELETE_ALL_DOMINATION_FORM_API = '/domination/delete-all-domination-forms'; 

// Abdl forms API
export const SUBMIT_ABDL_FORM_API = '/abdl/create-new-abdl-form'; 
export const GET_ALL_ABDL_FROMS_API = '/abdl/get-all-abdl-forms'; 
export const DELETE_ABDL_FORM_API = '/abdl/delete-abdl-form'; 
export const DELETE_ALL_ABDL_FORM_API = '/abdl/delete-all-abdl-forms'; 

// Review API routes
export const GET_REVIEWS_API = '/reviews/get-all-reviews';
export const CREATE_NEW_REVIEW_API = '/reviews/create-new-review';
export const DELETE_REVIEW_API = '/reviews/delete-review'; // /:reviewId

// Blog API routes
export const GET_BLOG_POSTS_API = '/blog/get-all-blog-posts';
export const GET_BLOG_POST_BY_TITLE_API = '/blog/get-all-blog-posts';

// Booking routes
export const GET_BOOKING_DATA_API = '/bookings/get-booking-data';
export const GET_BOOKING_ADMIN_API = '/bookings/get-all-bookings-admin';
export const CREATE_NEW_BOOKING_API = '/bookings/create-new-booking';
export const CONFIRM_BOOKING_API = '/bookings/confirm-booking';
export const SET_BOOKING_DAY_CLOSED_API = '/bookings/set-day-closed';
export const SET_BOOKING_DAY_OPEN_API = '/bookings/remove-day-closed';
export const EDIT_OPENING_TIMES_API = '/bookings/edit-opening-times';
export const DENY_BOOKING_API = '/bookings/deny-booking';
export const CANCEL_BOOKING_API = '/bookings/cancel-booking';
export const EDIT_BOOKING_API = '/bookings/edit-booking';
export const DELETE_BOOKING_API = '/bookings/delete-booking';
export const DELETE_ALL_BOOKING_API = '/bookings/delete-all-bookings';

